export class ASDTypes {
  public static readonly ASD = 'AppStateDocument';
  public static readonly CASD = 'CustomAppStateDocument';
  public static readonly DD = 'DesignDocument';
  public static readonly PASD = 'PayloadAppStateDocument';
  public static readonly TASD = 'TemplateAppStateDocument';

  public static readonly ListViewTypeDID = '481a248d-c8d0-4cec-a62d-ade7611ea7f8';
  public static readonly EntityViewTypeDID = '1037c2c3-97dc-4635-8497-2e06b07c7aff';
  public static readonly WizardViewTypeDID = 'fd004bca‑d51f‑4d27‑b222‑493c41735a91';
}
